import { render } from "./setpPayPass.vue?vue&type=template&id=85716bdc&scoped=true"
import script from "./setpPayPass.vue?vue&type=script&lang=js"
export * from "./setpPayPass.vue?vue&type=script&lang=js"

import "./setpPayPass.vue?vue&type=style&index=0&id=85716bdc&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85716bdc"]])

export default __exports__